import React, { forwardRef } from 'react';
import { Search } from 'lucide-react';

/**
 * Universal Search Input Component
 * 
 * A reusable search input component that ensures consistent
 * icon placement, spacing, and behavior across the entire application.
 * 
 * @param {string} value - Current input value
 * @param {function} onChange - Change handler
 * @param {string} placeholder - Placeholder text
 * @param {string} className - Additional CSS classes
 * @param {object} props - Additional input props
 */
const UniversalSearchInput = forwardRef(({ 
  value = '', 
  onChange, 
  placeholder = 'Search...', 
  className = '',
  ...props 
}, ref) => {
  return (
    <div className={`ui-search ${className}`}>
      {/* Search Icon - Always visible, properly positioned */}
      <span className="ui-search-icon">🔍</span>
      
      {/* Input Field - Proper padding to avoid text overlap */}
      <input
        ref={ref}
        type="text"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className="ui-search-input"
        {...props}
      />
    </div>
  );
});

UniversalSearchInput.displayName = 'UniversalSearchInput';

export default UniversalSearchInput;
